import { Component, Input, OnInit } from '@angular/core';
import { TranslationManager, ViewState } from 'src/common';
import { DocumentComponentName } from 'src/common/enums/documentComponentName';

@Component({
  selector: 'supplier-offer-documents',
  templateUrl: 'supplier-offer-documents.component.html'
})

export class SupplierOfferDocumentsComponent implements OnInit {

  @Input() supplierOfferId: number;
  @Input() state: ViewState;

  documentComponentName: DocumentComponentName;
  title1:string;
  title2:string;
  translationManager = TranslationManager;
  constructor() { }

  ngOnInit(): void {
    this.documentComponentName= DocumentComponentName.SupplierOffer;
    this.title1=this.translationManager.getTranslation('Захтеви - имплементација докумената');
    this.title2=this.translationManager.getTranslation('Страница за преглед и додавање докумената захтеву');
  }

}
